import { CIcon } from '~/icons/types'
export const ciProduct: CIcon = {
  name: 'product',
  type: 'light',
  width: 480,
  height: 480,
  paths: [
    {
      d:
        'M168 160a63.761 63.761 0 0 0-18.055-44.45 47.891 47.891 0 0 1 51.64 10.16l11.2-11.42c-20.512-20.15-51.965-24.08-76.8-9.603a63.89 63.89 0 0 0-64-.12A63.882 63.882 0 0 0 40 160v32H8a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8h168v-16H80V208h24v32h16v-32h56v-16h-8zM46.656 419.559a8.312 8.312 0 0 0-13.312 0L16 445.602V226.398l17.344 26.016a7.997 7.997 0 0 0 13.312 0L64 226.398v219.204zM57.055 464h-34.11L40 438.398zM40 233.602 22.945 208h34.11zM56 192v-32a47.946 47.946 0 0 1 66.055-44.45A63.761 63.761 0 0 0 104 160v32zm64-32a47.832 47.832 0 0 1 16-35.672A47.832 47.832 0 0 1 152 160v32h-32zm0 0'
    },
    {
      d:
        'M255.2 107.574A8.024 8.024 0 0 0 256 104V48h32v56a8.024 8.024 0 0 0 .8 3.574l48 96 14.321-7.148L304 102.113V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v94.113l-47.16 94.313A7.985 7.985 0 0 0 192 200v272a8 8 0 0 0 8 8h56v-16h-48V201.887zM288 16v16h-32V16zm0 0'
    },
    {
      d:
        'M478.871 307.902 448 253.88V224a8 8 0 0 0-8-8H312a8 8 0 0 0-8 8v29.879L273.055 308a7.935 7.935 0 0 0-1.055 4v160a8 8 0 0 0 8 8h192a8 8 0 0 0 8-8V312a7.933 7.933 0 0 0-1.129-4.098zM458.215 304h-36.43L440 272.129zM320 232h112v16H320zm-3.36 32h109.598l-22.879 40H293.762zM400 464H288V320h112zm64 0h-48V320h48zm0 0'
    }
  ]
}
